/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface QAResetPhoneHandlerBodyRequest {
  oldPhone: string;
  newPhone: string;
}

export interface QAResetPhoneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isSuccess: boolean;
    message: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface QAReservationSendMessageHandlerBodyRequest {
  /**
   * 병원 ID: 없을 경우 전체 처리
   * @example "6735db51805f6137a3386eb3"
   */
  hospitalID?: string;
  /**
   * 그룹 ID: 없을 경우 전체 처리
   * @example "6735db51805f6137a3386eb3"
   */
  groupID?: string;
  /**
   * 타겟 시간: 없을 경우 현재 시간을 반올림하여 정시
   * @format date
   * @example "2025-01-01T00:00:00.000Z"
   */
  targetDateTime?: string;
}

export interface QAReservationSendMessageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    success: boolean;
    day0Count?: number;
    day1Count?: number;
    day3Count?: number;
    results: {
      reservationID?: string;
      error?: string;
    }[];
    failedGroups?: {
      hospitalID?: string;
      groupID?: string;
      error?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type QaResetPhoneHandlerData = QAResetPhoneHandlerResponse;

export type QaReservationSendMessageHandlerData = QAReservationSendMessageHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 휴대폰번호 초기화 - 가입여부 상관없이 User, HService의 번호를 임의의 숫자로 초기화
     *
     * @tags V3-User
     * @name QaResetPhoneHandler
     * @summary 휴대폰번호 초기화 - 가입여부 상관없이 User, HService의 번호를 임의의 숫자로 초기화: ts
     * @request PATCH:/v3/api/qa/reset/phone
     * @secure
     * @response `200` `QaResetPhoneHandlerData` success
     */
    qaResetPhoneHandler: (data: QAResetPhoneHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<QaResetPhoneHandlerData, any>({
        path: `/v3/api/qa/reset/phone`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 예약 메시지 전송<br> 병원ID를 넣으면 해당 병원만 수행, 없으면 모든 병원 수행<br> 그룹ID를 넣으면 해당 그룹만 수행, 없으면 전체 그룹 수행<br> 타겟 시간을 넣으면 해당 시간으로 수행, 없으면 현재시간을 기준으로 수행
     *
     * @tags V3-ReservationGroup
     * @name QaReservationSendMessageHandler
     * @summary 예약 메시지 전송
     * @request POST:/v3/api/qa/reservation/sendmessage
     * @secure
     * @response `200` `QaReservationSendMessageHandlerData` success
     */
    qaReservationSendMessageHandler: (data: QAReservationSendMessageHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<QaReservationSendMessageHandlerData, any>({
        path: `/v3/api/qa/reservation/sendmessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
